import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { API_BASE_URL, MAPPING_FIELDS } from "../../../_contstants/common";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

export const getAllFacebookPages = createAsyncThunk(
  "me/accounts",
  async (accessToken: any) => {
    const response = await axiosApiInstance.get(`${API_BASE_URL}/me/accounts`, {
      params: {
        access_token: accessToken,
        pretty: 1,
        limit: 500,
        fields: "access_token,id,name",
      },
    });
    return response.data?.data
      ? response.data?.data.map((leadform: any) => leadform)
      : [];
  },
);

export const getAllFacebookBusinesses = createAsyncThunk(
  "me/businesses",
  async (accessToken: string) => {
    const response = await axiosApiInstance.get(
      `${API_BASE_URL}/me/businesses`,
      {
        params: {
          access_token: accessToken,
          fields: "id,name",
          limit: 500,
        },
      }
    );
    return response.data?.data
      ? response.data?.data.map((business: any) => business)
      : [];
  }
);

export const getPagesByBusinessID = createAsyncThunk(
  "business/owned_pages",
  async (formData: { businessId: string; accessToken: string }) => {
    const response = await axiosApiInstance.get(
      `${API_BASE_URL}/${formData.businessId}/owned_pages`,
      {
        params: {
          access_token: formData.accessToken,
          fields: "id,name,access_token",
          limit: 500,
        },
      }
    );
    return response.data?.data
      ? response.data?.data.map((page: any) => page)
      : [];
  }
);

export const getLeadFormByPageID = createAsyncThunk(
  "lead/leadgen_forms",
  async (formData: any) => {
    const response = await axiosApiInstance.get(
      `${API_BASE_URL}/${formData?.pageId}/leadgen_forms`,
      {
        params: {
          access_token: formData?.accessToken,
          pretty: 1,
          limit: 500,
        },
      },
    );
    return response.data?.data
      ? response.data?.data.map((leadform: any) => leadform)
      : [];
  },
);

export const getFormFieldsByFromID = createAsyncThunk(
  "forms/questions",
  async (formData: any) => {
    const response = await axiosApiInstance.get(
      `${API_BASE_URL}/${formData?.formId}?fields=questions&access_token=${formData?.accessToken}`,
    );
    return response.data?.questions
      ? response.data?.questions.map((question: any) => question)
      : [];
  },
);

//integration Section
export const getAllIntegrations = createAsyncThunk(
  "FacebookFormMapping/FindAll",
  async () => {
    const response = await axiosApiInstance.get(
      `${API_URL}/FacebookFormMapping/FindAll`,
    );
    return response.data.Data;
  },
);

export const createIntegration = createAsyncThunk(
  "FacebookFormMapping/InsertAndGet",
  async (formData: any) => {
    return await axiosApiInstance
      .post(`${API_URL}/FacebookFormMapping/InsertAndGet`, formData)
      .then((response) => {
        SuccessToast(response.data.Details);
        return response;
      });
  },
);

export const updateIntegration = createAsyncThunk(
  "FacebookFormMapping/UpdateAndGet",
  async (formData: any) => {
    return await axiosApiInstance
      .post(`${API_URL}/FacebookFormMapping/UpdateAndGet`, formData)
      .then((response) => {
        SuccessToast(response.data?.Message);
        return response;
      });
  },
);

export const getIntegrationByID = createAsyncThunk(
  "FacebookFormMapping/FindByID",
  async (ID: number) => {
    const response = await axiosApiInstance.post(
      `${API_URL}/FacebookFormMapping/FindByID`,
      {
        ID: ID,
      },
    );
    const integration: any = {
      ID: response.data.Data?.ID,
      Title: response.data.Data?.Title,
      FormID: response.data.Data?.FormID,
      PageID: response.data.Data?.PageID,
      SectorIDs: response.data.Data?.SectorIDs
        ? response.data.Data?.SectorIDs?.split(",")?.map(
            (sector: string) => +sector,
          )
        : [],
      // FileName: response.data.Data?.FileName
      //   ? response.data.Data?.FileName?.split(", ")
      //   : [],
      // MobileNo: response.data.Data?.MobileNo
      //   ? response.data.Data?.MobileNo?.split(", ")
      //   : [],
      // EmailID: response.data.Data?.EmailID
      //   ? response.data.Data?.EmailID?.split(", ")
      //   : [],
    };

    MAPPING_FIELDS.forEach(({ name }) => {
      const value = response.data.Data?.[name];
      integration[name] = value
        ? value.split(", ").map((v: string) => v.trim())
        : [];
    });

    return integration;
  },
);

export const deleteIntegration = createAsyncThunk(
  "FacebookFormMapping/Delete",
  (ID: number) =>
    axiosApiInstance
      .post(`${API_URL}/FacebookFormMapping/Delete`, {
        ID: ID,
      })
      .then((response) => {
        SuccessToast(response.data?.Details);
        return response;
      }),
);

export const getAllStudentLeads = createAsyncThunk(
  "FacebookFormMapping/FacebookLeadsByFormID",
  async (FormID: string) => {
    const response = await axiosApiInstance.post(
      `${API_URL}/FacebookFormMapping/FacebookLeadsByFormID`,
      {
        FormID: FormID,
      },
    );
    return response.data.Data;
  },
);

export const updatePageSubscription = createAsyncThunk(
  "FacebookFormMapping/PageSubscribe",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FacebookFormMapping/PageSubscribe`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Updating Subscription:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// TODO : need to change endpoint here
export const deleteFBLead = createAsyncThunk(
  "FacebookFormMapping/DeleteFacebookLeads",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FacebookFormMapping/DeleteFacebookLeads`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Inquiry", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// TODO : need to change endpoint here
export const disConnectFacebook = createAsyncThunk(
  "FacebookFormMapping/PageDisconnectFromFBUserID",
  async (FBUserID: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FacebookFormMapping/PageDisconnectFromFBUserID`,
        { FBUserID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Inquiry", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
